import * as React from 'react'
import styled from 'styled-components'

const SeparatorComponent = styled.div`
  width: 3rem;
  height: 3rem;
`

const Separator = (): JSX.Element => {
  return <SeparatorComponent />
}

export default Separator
